/**
 * PocketFiler - Russian (ru) Translation File
 * Complete translation - all keys from en.js
 */

const ru = {
  "nav.login": "Войти",
  "nav.signup": "Начать",
  "nav.logout": "Выйти",
  "nav.dashboard": "Панель",
  "nav.virtualOffices": "Виртуальные офисы",
  "nav.clients": "Клиенты",
  "nav.deals": "Сделки",
  "nav.documents": "Документы",
  "nav.messages": "Сообщения",
  "nav.settings": "Настройки",
  "nav.invoices": "Счета",
  "nav.templates": "Шаблоны",
  "nav.tasks": "Задачи",
  "nav.meetings": "Встречи",
  "nav.analytics": "Аналитика",
  "landing.badge": "Платформа сделок с ИИ",
  "landing.hero.title": "Закрывайте важные сделки на любом языке",
  "landing.hero.titleHighlight": "с ИИ",
  "landing.hero.subtitle": "PocketFiler помогает компаниям и частным лицам проводить документоёмкие, высокодоверительные транзакции — от глобальной торговли до местных продаж автомобилей и страховых полисов — с переводом ИИ, документооборотом и комнатами сделок для каждой транзакции.",
  "landing.hero.cta.start": "Начать бесплатно",
  "landing.hero.cta.demo": "Как это работает",
  "landing.useCases.title": "Создано для глобальной торговли, местных услуг и крупных личных сделок",
  "landing.useCases.subtitle": "Импортируете ли вы товары из-за рубежа или продаёте машину в городе, PocketFiler даёт инструменты для уверенного завершения сделки.",
  "landing.useCases.globalTrade.title": "Глобальная торговля и производство",
  "landing.useCases.globalTrade.desc": "Находите и работайте с зарубежными поставщиками, собирайте документы соответствия и ведите переговоры в комнатах сделок с переводом в реальном времени.",
  "landing.useCases.insurance.title": "Страхование, кредитование и профессиональные услуги",
  "landing.useCases.insurance.desc": "Приглашайте клиентов загружать документы, выписки и формы на своём языке, затем отслеживайте каждый документ и сообщение в виртуальных офисах.",
  "landing.useCases.realEstate.title": "Недвижимость и сделки с имуществом",
  "landing.useCases.realEstate.desc": "Проводите покупателей и арендаторов через заявки, раскрытия и контракты на разных языках, всё в одной комнате сделок на транзакцию.",
  "landing.useCases.vehicle.title": "Частные продажи транспорта и активов",
  "landing.useCases.vehicle.desc": "Используйте комнаты сделок и контракты, сгенерированные ИИ, для оформления купчих и документации на автомобили, оборудование и другие ценные предметы.",
  "landing.audience.title": "Создано для частных лиц и команд",
  "landing.audience.individuals.title": "Для частных лиц",
  "landing.audience.individuals.bullet1": "Завершайте важные разовые сделки, такие как покупка автомобиля, оборудования или ценных предметов с чёткими записями.",
  "landing.audience.individuals.bullet2": "Используйте простые безопасные ссылки для загрузки документов и просмотра контрактов с телефона.",
  "landing.audience.individuals.bullet3": "Храните все сообщения, файлы и черновики контрактов для каждой сделки в одном месте, даже после её завершения.",
  "landing.audience.teams.title": "Для бизнеса и команд",
  "landing.audience.teams.bullet1": "Создавайте виртуальные офисы для каждой линии услуг (страхование, недвижимость, кредитование, импорт) с настроенными чек-листами.",
  "landing.audience.teams.bullet2": "Приглашайте клиентов на любом языке загружать документы, подписывать контракты и общаться в комнатах сделок.",
  "landing.audience.teams.bullet3": "Дайте команде общее рабочее пространство с хронологией, резюме ИИ и полной историей каждой транзакции.",
  "landing.howItWorks.title": "Как PocketFiler работает для любой сделки",
  "landing.howItWorks.subtitle": "Четыре мощные функции, которые работают вместе, чтобы помочь вам закрывать сделки быстрее и с меньшим трением.",
  "landing.howItWorks.concierge.title": "ИИ-консьерж",
  "landing.howItWorks.concierge.desc": "Ваш ИИ-ассистент изучает ваш бизнес, настраивает правильные виртуальные офисы и создаёт чек-листы документов для каждого типа транзакции.",
  "landing.howItWorks.translation.title": "Автоперевод",
  "landing.howItWorks.translation.desc": "Сообщения и ключевой контент мгновенно переводятся между сторонами, чтобы покупатели, продавцы и клиенты могли общаться на своём языке.",
  "landing.howItWorks.documents.title": "Умные документы",
  "landing.howItWorks.documents.desc": "Клиенты загружают документы с телефона; ИИ извлекает ключевые поля, проверяет качество и отмечает проблемы до того, как они замедлят сделку.",
  "landing.howItWorks.dealRooms.title": "Комнаты сделок и контракты",
  "landing.howItWorks.dealRooms.desc": "Каждая сделка получает выделенную комнату с хронологией, сообщениями, документами и черновиками контрактов от ИИ, которые можно просмотреть и утвердить.",
  "landing.cta.title": "Готовы закрыть следующую сделку?",
  "landing.cta.subtitle": "Присоединяйтесь к компаниям и частным лицам, использующим PocketFiler для уверенного проведения важных транзакций.",
  "landing.cta.button": "Создать бесплатный аккаунт",
  "landing.footer.tagline": "Важные сделки — просто.",
  "language.picker.title": "Выберите ваш язык",
  "language.picker.subtitle": "Мы покажем все инструкции, сообщения и контракты на этом языке. Другие могут выбрать свой язык; ИИ позаботится о переводе.",
  "language.picker.continue": "Продолжить",
  "language.picker.playSample": "Прослушать пример",
  "language.picker.playing": "Воспроизведение...",
  "language.picker.confirmation": "Вы выбрали {language}. Мы покажем всё на этом языке. Другие могут выбрать свой язык; PocketFiler переводит сообщения, документы и контракты, чтобы все понимали.",
  "language.toast.saved": "Язык сохранён! Чтобы изменить, перейдите в Настройки в профиле.",
  "language.confirm.title": "Подтвердите ваш язык",
  "language.confirm.subtitle": "Этот язык будет использоваться для всего интерфейса, сообщений и контрактов.",
  "language.confirm.change": "Изменить язык",
  "language.confirm.continue": "Продолжить с",
  "language.confirm.chineseNote": "Примечание: Вы выбрали упрощённый китайский (简体中文). Если вы предпочитаете традиционный китайский, пожалуйста, измените выбор.",
  "auth.login.title": "С возвращением",
  "auth.login.subtitle": "Войдите в аккаунт PocketFiler",
  "auth.login.email": "Email",
  "auth.login.password": "Пароль",
  "auth.login.submit": "Войти",
  "auth.login.noAccount": "Нет аккаунта?",
  "auth.login.signupLink": "Зарегистрироваться",
  "auth.login.error": "Неверный email или пароль",
  "auth.signup.title": "Создайте аккаунт",
  "auth.signup.subtitle": "Начните заключать сделки на любом языке",
  "auth.signup.name": "Полное имя",
  "auth.signup.email": "Email",
  "auth.signup.password": "Пароль",
  "auth.signup.confirmPassword": "Подтвердите пароль",
  "auth.signup.companyName": "Название компании",
  "auth.signup.companyType": "Тип отрасли",
  "auth.signup.submit": "Создать аккаунт",
  "auth.signup.hasAccount": "Уже есть аккаунт?",
  "auth.signup.loginLink": "Войти",
  "auth.signup.terms": "Регистрируясь, вы соглашаетесь с нашими Условиями использования и Политикой конфиденциальности.",
  "dashboard.title": "Панель",
  "dashboard.welcome": "С возвращением, {name}",
  "dashboard.aiSummary.title": "Резюме ИИ",
  "dashboard.aiSummary.generating": "Генерация резюме...",
  "dashboard.stats.totalDeals": "Всего сделок",
  "dashboard.stats.activeDeals": "Активные сделки",
  "dashboard.stats.totalClients": "Всего клиентов",
  "dashboard.stats.documentsProcessed": "Обработано документов",
  "dashboard.recentDeals.title": "Недавние сделки",
  "dashboard.recentDeals.viewAll": "Показать все",
  "dashboard.recentDeals.empty": "Пока нет сделок. Создайте первую сделку, чтобы начать.",
  "dashboard.recentClients.title": "Недавние клиенты",
  "dashboard.recentClients.viewAll": "Показать все",
  "dashboard.recentClients.empty": "Пока нет клиентов. Пригласите первого клиента, чтобы начать.",
  "dashboard.quickActions.title": "Быстрые действия",
  "dashboard.quickActions.createDeal": "Создать сделку",
  "dashboard.quickActions.inviteClient": "Пригласить клиента",
  "dashboard.quickActions.createOffice": "Создать виртуальный офис",
  "offices.title": "Виртуальные офисы",
  "offices.subtitle": "Организуйте бизнес по типам услуг",
  "offices.create": "Создать виртуальный офис",
  "offices.empty.title": "Пока нет виртуальных офисов",
  "offices.empty.desc": "Создайте первый виртуальный офис для организации сделок и клиентов.",
  "offices.card.clients": "{count} клиентов",
  "offices.card.deals": "{count} сделок",
  "offices.card.checklist": "Пунктов чек-листа",
  "offices.checklist": "Чек-лист документов",
  "offices.noChecklist": "Документы не требуются",
  "offices.dialog.title": "Создать виртуальный офис",
  "offices.dialog.desc": "Настройте новое рабочее пространство для определённого типа услуг",
  "offices.dialog.name": "Название офиса",
  "offices.dialog.namePlaceholder": "напр., Страховые претензии, Продажа недвижимости",
  "offices.dialog.type": "Тип офиса",
  "offices.dialog.description": "Описание",
  "offices.dialog.descriptionPlaceholder": "Опишите, чем занимается этот офис...",
  "offices.dialog.checklist": "Чек-лист документов",
  "offices.dialog.checklistHelp": "ИИ-генерируемый чек-лист необходимых документов",
  "offices.dialog.addItem": "Добавить пункт",
  "offices.dialog.generateChecklist": "Сгенерировать с ИИ",
  "offices.dialog.creating": "Создание...",
  "offices.dialog.create": "Создать офис",
  "offices.form.name": "Название офиса",
  "offices.form.namePlaceholder": "напр., Страховые услуги, Недвижимость и т.д.",
  "offices.form.description": "Описание",
  "offices.form.descPlaceholder": "Какие типы сделок будет обрабатывать этот офис?",
  "offices.form.checklistPlaceholder": "Добавить необходимый документ...",
  "offices.ai.title": "ИИ-помощник настройки",
  "offices.ai.desc": "Позвольте нашему ИИ-консьержу помочь вам настроить идеальный виртуальный офис, задав вопросы о потребностях вашего бизнеса.",
  "offices.ai.manual": "Настроить вручную",
  "offices.ai.start": "Начать ИИ-настройку",
  "offices.ai.startOnboarding": "Помогите мне настроить виртуальный офис",
  "offices.ai.suggestion": "Предложение ИИ",
  "offices.ai.acceptSuggestion": "Принять и создать офис",
  "offices.ai.inputPlaceholder": "Введите ваш ответ...",
  "clients.title": "Клиенты",
  "clients.subtitle": "Управляйте клиентами и приглашениями",
  "clients.invite": "Пригласить клиента",
  "clients.empty.title": "Пока нет клиентов",
  "clients.empty.desc": "Пригласите первого клиента, чтобы начать.",
  "clients.table.name": "Имя",
  "clients.table.client": "Клиент",
  "clients.table.contact": "Контакт",
  "clients.table.office": "Офис",
  "clients.table.language": "Язык",
  "clients.table.status": "Статус",
  "clients.table.actions": "Действия",
  "clients.status.invited": "Приглашён",
  "clients.status.active": "Активен",
  "clients.status.completed": "Завершён",
  "clients.dialog.title": "Пригласить нового клиента",
  "clients.dialog.name": "Имя клиента",
  "clients.dialog.email": "Email адрес",
  "clients.dialog.phone": "Номер телефона",
  "clients.dialog.office": "Виртуальный офис",
  "clients.dialog.language": "Предпочитаемый язык",
  "clients.dialog.sending": "Отправка приглашения...",
  "clients.dialog.send": "Отправить приглашение",
  "clients.toast.invited": "Приглашение отправлено {name}",
  "clients.toast.deleted": "Клиент удалён",
  "clients.toast.linkCopied": "Ссылка-приглашение скопирована в буфер обмена",
  "clients.invite.step1Title": "Пригласить нового клиента",
  "clients.invite.step2Title": "Предпросмотр сообщения",
  "clients.invite.step3Title": "Приглашение отправлено!",
  "clients.invite.step1Desc": "Введите контактную информацию клиента",
  "clients.invite.step2Desc": "Просмотрите и настройте сообщение-приглашение",
  "clients.invite.step3Desc": "Поделитесь ссылкой с клиентом",
  "clients.invite.nameLabel": "Имя клиента",
  "clients.invite.namePlaceholder": "напр., Иван Иванов",
  "clients.invite.contactMethod": "Способ связи",
  "clients.invite.phone": "Номер телефона",
  "clients.invite.customNote": "Примечание",
  "clients.invite.customNotePlaceholder": "Особые инструкции для этого клиента...",
  "clients.invite.previewMessage": "Предпросмотр сообщения",
  "clients.invite.aiGenerated": "ИИ-сгенерированное приглашение",
  "clients.invite.messagePreview": "Предпросмотр сообщения",
  "clients.invite.messageEditHint": "Вы можете отредактировать это сообщение перед отправкой",
  "clients.invite.documentsRequested": "Запрошенные документы",
  "clients.invite.regenerate": "Сгенерировать заново",
  "clients.invite.sendInvite": "Отправить приглашение",
  "clients.invite.linkCreated": "Ссылка создана!",
  "clients.invite.linkCopiedToClipboard": "Ссылка скопирована в буфер обмена",
  "clients.invite.shareLink": "Поделитесь этой ссылкой с клиентом по email, SMS или лично",
  "clients.invite.inviteAnother": "Пригласить ещё",
  "clients.invite.success": "Клиент приглашён!",
  "clients.invite.linkCopied": "Ссылка скопирована!",
  "clients.invite.yourAgent": "Ваш агент",
  "clients.invite.defaultOffice": "Наш офис",
  "deals.title": "Сделки",
  "deals.subtitle": "Отслеживайте и управляйте транзакциями",
  "deals.create": "Создать сделку",
  "deals.empty.title": "Пока нет сделок",
  "deals.empty.desc": "Создайте первую сделку, чтобы начать.",
  "deals.search": "Поиск сделок...",
  "deals.filter.all": "Все сделки",
  "deals.filter.active": "Активные",
  "deals.filter.pending": "Ожидающие",
  "deals.filter.closed": "Закрытые",
  "deals.column.draft": "Черновик",
  "deals.column.active": "Активные",
  "deals.column.pending": "Ожидающие",
  "deals.column.closed": "Закрытые",
  "deals.card.documents": "{count} документов",
  "deals.card.messages": "{count} сообщений",
  "deals.dialog.title": "Создать новую сделку",
  "deals.dialog.dealTitle": "Название сделки",
  "deals.dialog.dealTitlePlaceholder": "напр., Покупка автомобиля - Honda Civic 2023",
  "deals.dialog.client": "Клиент",
  "deals.dialog.office": "Виртуальный офис",
  "deals.dialog.type": "Тип сделки",
  "deals.dialog.notes": "Заметки",
  "deals.dialog.notesPlaceholder": "Добавьте заметки о сделке...",
  "deals.dialog.creating": "Создание...",
  "deals.dialog.create": "Создать сделку",
  "dealRoom.back": "Назад к сделкам",
  "dealRoom.readOnly.title": "Только чтение",
  "dealRoom.readOnly.closedMessage": "Эта сделка закрыта. Комната сделок доступна только для чтения в справочных и аудиторских целях.",
  "dealRoom.readOnly.cancelledMessage": "Эта сделка отменена. Комната сделок доступна только для чтения в справочных и аудиторских целях.",
  "dealRoom.tabs.messages": "Сообщения",
  "dealRoom.tabs.documents": "Документы",
  "dealRoom.tabs.contract": "Контракт",
  "dealRoom.timeline.title": "Хронология активности",
  "dealRoom.timeline.empty": "Пока нет активности",
  "dealRoom.details.title": "Детали сделки",
  "dealRoom.details.notes": "Заметки",
  "dealRoom.details.type": "Тип",
  "dealRoom.details.documents": "Документы",
  "dealRoom.details.messages": "Сообщения",
  "dealRoom.aiSummary.title": "Резюме ИИ",
  "dealRoom.aiSummary.generating": "Генерация резюме...",
  "dealRoom.messages.empty": "Пока нет сообщений. Начните разговор.",
  "dealRoom.messages.placeholder": "Введите сообщение...",
  "dealRoom.messages.send": "Отправить",
  "dealRoom.messages.sending": "Отправка...",
  "dealRoom.messages.showOriginal": "Показать оригинал",
  "dealRoom.messages.showTranslation": "Показать перевод",
  "dealRoom.messages.translatedFrom": "Переведено с {language}",
  "dealRoom.messages.suggestReply": "Предложить ответ",
  "dealRoom.documents.empty": "Документы пока не загружены.",
  "dealRoom.documents.upload": "Загрузить документ",
  "dealRoom.documents.uploading": "Загрузка...",
  "dealRoom.documents.analyze": "Анализ",
  "dealRoom.documents.analyzing": "Анализируем...",
  "dealRoom.documents.download": "Скачать",
  "dealRoom.documents.delete": "Удалить",
  "dealRoom.documents.pending": "Ожидает анализа",
  "dealRoom.documents.analyzed": "Проанализирован",
  "dealRoom.documents.aiAnalysis": "ИИ-анализ документа",
  "dealRoom.documents.type": "Тип документа",
  "dealRoom.documents.confidence": "Уверенность",
  "dealRoom.documents.summary": "Резюме",
  "dealRoom.documents.issues": "Проблемы",
  "dealRoom.contract.empty.title": "Контракт ещё не создан",
  "dealRoom.contract.empty.desc": "Создайте ИИ-черновик контракта для этой сделки.",
  "dealRoom.contract.generate": "Создать черновик контракта",
  "dealRoom.contract.regenerate": "Создать заново",
  "dealRoom.contract.generating": "Создание...",
  "dealRoom.contract.aiLabel": "ИИ-сгенерированный черновик контракта",
  "dealRoom.contract.language": "Язык",
  "dealRoom.contract.copy": "Копировать",
  "dealRoom.contract.copied": "Скопировано в буфер обмена",
  "dealRoom.contract.type": "Тип контракта",
  "dealRoom.contract.generated": "Создан",
  "dealRoom.contract.languages": "Языки",
  "dealRoom.contract.status": "Статус",
  "dealRoom.contract.notice": "ИИ-анализ документа: Один или несколько пунктов не имеют прямого эквивалента между выбранными языками. Мы использовали описательный язык. Пожалуйста, внимательно проверьте эти разделы и при необходимости уточните у другой стороны.",
  "dealRoom.contract.dialog.title": "Создать черновик контракта",
  "dealRoom.contract.dialog.desc": "ИИ создаст двуязычный контракт на основе деталей сделки.",
  "dealRoom.contract.dialog.disclaimer": "Это ИИ-сгенерированный черновик для ознакомления. Попросите юриста проверить его перед подписанием.",
  "dealRoom.contract.dialog.type": "Тип контракта",
  "dealRoom.contract.dialog.languages": "Языки",
  "dealRoom.contract.dialog.languagesHelp": "Выберите два языка для двуязычного контракта. Все языки Tier 1 полностью поддерживаются.",
  "dealRoom.contract.dialog.primary": "Основной",
  "dealRoom.contract.dialog.secondary": "Дополнительный",
  "dealRoom.contract.dialog.terms": "Особые условия",
  "dealRoom.contract.dialog.termsPlaceholder": "Добавьте особые условия или требования...",
  "dealRoom.contract.dialog.generate": "Создать контракт",
  "dealRoom.contract.dialog.generating": "Создание...",
  "dealRoom.status.change": "Изменить статус",
  "dealRoom.status.dialog.title": "Изменить статус сделки",
  "dealRoom.status.dialog.from": "С",
  "dealRoom.status.dialog.to": "На",
  "dealRoom.status.dialog.reason": "Причина (необязательно)",
  "dealRoom.status.dialog.reasonPlaceholder": "Почему вы меняете статус?",
  "dealRoom.status.dialog.confirm": "Подтвердить изменение",
  "dealRoom.status.dialog.changing": "Изменение...",
  "dealRoom.status.toast.changed": "Статус изменён на {status}",
  "dealRoom.upgrade.title": "Перейти на Бизнес",
  "dealRoom.upgrade.desc": "Создание контрактов требует тарифа Бизнес.",
  "dealRoom.upgrade.features": "С тарифом Бизнес вы получите:",
  "dealRoom.upgrade.feature1": "ИИ-сгенерированные черновики контрактов",
  "dealRoom.upgrade.feature2": "Расширенный анализ документов",
  "dealRoom.upgrade.feature3": "Приоритетная поддержка",
  "dealRoom.upgrade.button": "Перейти сейчас",
  "settings.title": "Настройки",
  "settings.subtitle": "Управляйте аккаунтом и организацией",
  "settings.tabs.profile": "Профиль",
  "settings.tabs.organization": "Организация",
  "settings.profile.title": "Настройки профиля",
  "settings.profile.subtitle": "Управляйте личной информацией",
  "settings.profile.name": "Полное имя",
  "settings.profile.email": "Email",
  "settings.profile.emailNote": "Email нельзя изменить",
  "settings.profile.language": "Предпочитаемый язык",
  "settings.profile.languageHelp": "Весь интерфейс, сообщения и контракты будут на этом языке.",
  "settings.profile.save": "Сохранить изменения",
  "settings.profile.saving": "Сохранение...",
  "settings.profile.saved": "Профиль обновлён",
  "settings.org.title": "Настройки организации",
  "settings.org.subtitle": "Управляйте информацией о бизнесе",
  "settings.org.name": "Название организации",
  "settings.org.type": "Тип отрасли",
  "settings.org.billingEmail": "Email для счетов",
  "settings.org.plan": "Тариф",
  "settings.org.verification": "Статус верификации",
  "settings.org.save": "Сохранить изменения",
  "settings.org.saving": "Сохранение...",
  "settings.org.saved": "Организация обновлена",
  "settings.org.noOrg": "Организация не найдена",
  "invite.language.title": "Выберите ваш язык",
  "invite.language.subtitle": "Мы покажем все инструкции на вашем языке.",
  "invite.welcome.title": "Добро пожаловать в",
  "invite.welcome.subtitle": "Мы готовы принять ваши документы.",
  "invite.welcome.time": "5-10 минут",
  "invite.welcome.timeLabel": "Примерное время",
  "invite.welcome.secure": "Безопасно и бесплатно",
  "invite.welcome.secureDesc": "Ваши документы зашифрованы. Эта услуга бесплатна для вас.",
  "invite.welcome.start": "Начать загрузку",
  "invite.documents.needed": "Необходимые документы",
  "invite.upload.title": "Загрузить документ",
  "invite.upload.dragDrop": "Перетащите файл сюда или нажмите для выбора",
  "invite.upload.or": "или",
  "invite.upload.takePhoto": "Изображения",
  "invite.upload.browse": "Файлы",
  "invite.upload.uploading": "Загрузка...",
  "invite.upload.analyzing": "Проверка документа...",
  "invite.upload.success": "Успешно загружено",
  "invite.upload.next": "Следующий документ",
  "invite.upload.finish": "Проверить всё",
  "invite.upload.skip": "Пропустить пока",
  "invite.upload.progress": "Прогресс",
  "invite.complete.title": "Готово!",
  "invite.complete.subtitle": "Ваши документы успешно отправлены.",
  "invite.complete.message": "Мы получили все ваши документы. Свяжемся с вами в ближайшее время.",
  "invite.complete.summary": "Отправленные документы",
  "invite.complete.securityNote": "Ваши документы хранятся безопасно и доступны только уполномоченным сотрудникам.",
  "invite.chat.title": "Чат с агентом",
  "invite.chat.placeholder": "Введите сообщение...",
  "invite.chat.empty": "Пока нет сообщений. Начните разговор.",
  "invite.chat.sent": "Ваше сообщение отправлено.",
  "invite.chat.willRespond": "Мы ответим как можно скорее.",
  "invite.chat.sending": "Отправка...",
  "invite.error.title": "Недействительная или устаревшая ссылка",
  "invite.error.message": "Эта ссылка-приглашение больше недействительна. Пожалуйста, запросите новую ссылку у отправителя.",
  "common.loading": "Загрузка...",
  "common.save": "Сохранить",
  "common.cancel": "Отмена",
  "common.delete": "Удалить",
  "common.edit": "Редактировать",
  "common.create": "Создать",
  "common.close": "Закрыть",
  "common.dismiss": "Закрыть",
  "common.confirm": "Подтвердить",
  "common.back": "Назад",
  "common.next": "Далее",
  "common.previous": "Назад",
  "common.of": "из",
  "common.search": "Поиск",
  "common.filter": "Фильтр",
  "common.sort": "Сортировка",
  "common.viewAll": "Показать все",
  "common.refresh": "Обновить",
  "common.retry": "Повторить",
  "common.yes": "Да",
  "common.no": "Нет",
  "common.or": "или",
  "common.and": "и",
  "common.optional": "необязательно",
  "common.required": "обязательно",
  "status.draft": "Черновик",
  "status.active": "Активна",
  "status.pending": "Ожидает",
  "status.pending_documents": "Ожидает документов",
  "status.pending_signature": "Ожидает подписи",
  "status.on_hold": "Приостановлена",
  "status.closed": "Закрыта",
  "status.cancelled": "Отменена",
  "error.generic": "Что-то пошло не так. Попробуйте ещё раз.",
  "error.network": "Ошибка сети. Проверьте подключение.",
  "error.unauthorized": "У вас нет прав для выполнения этого действия.",
  "error.notFound": "Запрошенный ресурс не найден.",
  "error.validation": "Проверьте введённые данные и попробуйте снова.",
  "error.serverError": "Ошибка сервера. Попробуйте позже.",
  "success.saved": "Изменения успешно сохранены.",
  "success.created": "Успешно создано.",
  "success.deleted": "Успешно удалено.",
  "success.sent": "Успешно отправлено.",
  "success.uploaded": "Успешно загружено.",
  "time.justNow": "Только что",
  "time.minutesAgo": "{count} минут назад",
  "time.hoursAgo": "{count} часов назад",
  "time.daysAgo": "{count} дней назад",
  "time.today": "Сегодня",
  "time.yesterday": "Вчера",
  "dealRoom.notFound": "Сделка не найдена",
  "dealRoom.loading": "Загрузка сделки...",
  "dealRoom.conversation.title": "Переписка по сделке",
  "dealRoom.conversation.you": "Вы",
  "dealRoom.conversation.client": "Клиент",
  "dealRoom.messages.hideOriginal": "Скрыть оригинал",
  "dealRoom.messages.original": "Оригинал ({language})",
  "dealRoom.messages.disabled": "Сообщения отключены для этого статуса сделки",
  "dealRoom.messages.aiSuggest": "ИИ-предложенный ответ",
  "dealRoom.documents.title": "Документы",
  "dealRoom.documents.uploadDisabled": "Загрузка отключена",
  "dealRoom.documents.pendingAnalysis": "Ожидает анализа",
  "dealRoom.documents.uploadFirst": "Загрузить первый документ",
  "dealRoom.documents.uploadHelp": "Загрузите документы для ИИ-анализа",
  "dealRoom.documents.uploadDisabledHelp": "Загрузка документов отключена для этого статуса сделки",
  "dealRoom.documents.analyzeWithAI": "Анализировать с ИИ",
  "dealRoom.documents.notAnalyzed": "Ещё не проанализирован",
  "dealRoom.documents.notAnalyzedHelp": "Запустите ИИ-анализ для извлечения типа документа, полей и получения рекомендаций",
  "dealRoom.documents.analyzeDocument": "Анализировать документ",
  "dealRoom.documents.extractedFields": "Извлечённые поля",
  "dealRoom.documents.issuesDetected": "Обнаруженные проблемы",
  "dealRoom.documents.preview": "Предпросмотр",
  "dealRoom.documents.uploaded": "Загружен",
  "dealRoom.documents.deleteConfirm": "Вы уверены, что хотите удалить этот документ?",
  "dealRoom.onHold.message": "Эта сделка приостановлена. Загрузка документов отключена. Вы всё ещё можете отправлять сообщения для координации.",
  "dealRoom.pendingSignature.message": "Контракт готов к подписанию. Загрузка документов отключена до подписания или отмены контракта.",
  "dealRoom.status.current": "текущий",
  "dealRoom.status.finalWarning": "Это конечное состояние. Сделку нельзя будет открыть повторно после этого действия.",
  "dealRoom.contract.purchaseAgreement": "Договор купли-продажи",
  "dealRoom.contract.purchaseAgreementDesc": "Стандартный договор купли-продажи",
  "dealRoom.contract.noContract": "Пока нет контракта",
  "dealRoom.contract.noContractDesc": "Создайте ИИ-черновик контракта на основе деталей сделки и документов.",
  "dealRoom.contract.notAvailable": "Создание контракта недоступно для сделок со статусом {status}.",
  "dealRoom.contract.locked": "Создание контракта заблокировано в ожидании подписи.",
  "dealRoom.contract.requiresPlan": "Требуется тариф Business Starter",
  "dealRoom.toast.dealUpdated": "Сделка обновлена",
  "dealRoom.toast.statusChanged": "Статус сделки изменён на {status}",
  "dealRoom.toast.statusFailed": "Не удалось изменить статус",
  "dealRoom.toast.contractGenerated": "Черновик контракта успешно создан",
  "dealRoom.toast.contractCopied": "Контракт на {language} скопирован в буфер обмена",
  "dealRoom.toast.messageFailed": "Не удалось отправить сообщение",
  "dealRoom.toast.suggestionFailed": "Не удалось создать предложение",
  "dealRoom.toast.documentUploaded": "Документ загружен",
  "dealRoom.toast.uploadFailed": "Ошибка загрузки",
  "dealRoom.toast.analysisComplete": "ИИ-анализ документа завершён",
  "dealRoom.toast.analysisFailed": "ИИ-анализ не удался",
  "dealRoom.toast.documentDeleted": "Документ удалён",
  "dealRoom.toast.deleteFailed": "Не удалось удалить",
  "dealRoom.details.created": "Создана",
  "dealRoom.details.addNotes": "Добавить заметки о сделке...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Пропустить пока",
  "onboarding.badge": "ИИ-настройка",
  "onboarding.welcome": "Добро пожаловать, {name}!",
  "onboarding.welcomeGeneric": "Добро пожаловать!",
  "onboarding.subtitle": "Давайте настроим ваше рабочее пространство PocketFiler. Расскажите нашему ИИ-консьержу о вашем бизнесе, и мы всё настроим для вас.",
  "onboarding.step1": "Опишите ваш бизнес и потребности",
  "onboarding.step2": "ИИ предложит настройку",
  "onboarding.step3": "Начните управлять сделками",
  "onboarding.concierge.title": "ИИ-консьерж",
  "onboarding.toast.officeCreated": "Виртуальный офис создан!",
  "auth.signup.accountType": "Тип аккаунта",
  "auth.signup.passwordTooShort": "Пароль должен содержать не менее 8 символов",
  "auth.signup.passwordsDoNotMatch": "Пароли не совпадают",
  "auth.signup.success": "Аккаунт успешно создан!",
  "captions.connecting": "Подключение...",
  "captions.disable": "Отключить субтитры",
  "captions.enable": "Включить субтитры",
  "captions.error.connect": "Не удалось подключиться к сервису субтитров",
  "captions.error.toggle": "Не удалось переключить субтитры",
  "captions.language": "Язык субтитров",
  "captions.live": "В эфире",
  "captions.off": "Субтитры выкл",
  "captions.on": "Субтитры вкл",
  "captions.original": "Оригинал",
  "captions.translated": "Переведено",
  "captions.translating": "Перевод...",
  "clients.joined.empty.desc": "Вы ещё не присоединились ни к одной организации. Попросите их пригласить вас в их рабочее пространство PocketFiler.",
  "clients.joined.empty.title": "Не присоединились к организациям",
  "clients.nav.joinedOrgs": "Присоединённые организации",
  "clients.nav.myClients": "Мои клиенты",
  "clients.table.joinedDate": "Дата присоединения",
  "clients.table.organization": "Организация",
  "common.backToHome": "Вернуться на главную",
  "common.deleteConfirmDesc": "Это действие нельзя отменить. Это навсегда удалит элемент и удалит данные с наших серверов.",
  "common.deleteConfirmTitle": "Вы абсолютно уверены?",
  "common.noResults": "Результаты не найдены",
  "connect.createAccount": "Создать бесплатный аккаунт",
  "connect.dealCreated": "Сделка успешно создана",
  "connect.error.invalid": "Неверная ссылка подключения",
  "connect.error.invalidDesc": "Эта ссылка подключения недействительна или истекла.",
  "connect.error.server": "Что-то пошло не так",
  "connect.error.serverDesc": "Пожалуйста, попробуйте позже.",
  "connect.infoUnauth": "Этот человек использует PocketFiler для безопасного управления многоязычными сделками и документами.",
  "connect.joinOffice": "Присоединиться к виртуальному офису",
  "connect.loggedInAs": "Вошли как",
  "connect.login": "Войти",
  "connect.startDeal": "Начать сделку",
  "connect.titleAuth": "Вы подключаетесь к",
  "connect.titleUnauth": "Подключиться к",
  "connect.typeOrg": "Организация",
  "connect.typePerson": "Человек",
  "contacts.actions.call": "Позвонить",
  "contacts.actions.email": "Email",
  "contacts.actions.message": "Отправить сообщение в приложении",
  "contacts.actions.noEmail": "Нет email адреса",
  "contacts.actions.noPhone": "Нет номера телефона",
  "contacts.actions.sms": "SMS",
  "contacts.actions.title": "Контакт {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "Имя контакта",
  "contacts.dialog.title": "Добавить новый контакт",
  "contacts.empty.desc": "Добавьте первый контакт для начала работы.",
  "contacts.empty.title": "Пока нет контактов",
  "contacts.invite": "Добавить контакт",
  "contacts.invite.customNotePlaceholder": "Любые особые заметки об этом контакте...",
  "contacts.invite.nameLabel": "Имя контакта",
  "contacts.invite.shareLink": "Поделитесь этой ссылкой с контактом по email, SMS или лично",
  "contacts.invite.step1Desc": "Введите информацию о контакте",
  "contacts.invite.step1Title": "Добавить новый контакт",
  "contacts.subtitle": "Управляйте контактами и приглашениями",
  "contacts.table.contact": "Контакт",
  "contacts.title": "Контакты",
  "contacts.toast.deleted": "Контакт удалён",
  "contacts.toast.invited": "Контакт добавлен: {name}",
  "contacts.toast.linkCopied": "Ссылка скопирована в буфер обмена",
  "dashboard.quickActions.inviteContact": "Добавить контакт",
  "dashboard.recentContacts.empty": "Пока нет контактов. Пригласите первый контакт для начала работы.",
  "dashboard.recentContacts.title": "Недавние контакты",
  "dashboard.recentContacts.viewAll": "Показать все",
  "dashboard.stats.totalContacts": "Всего контактов",
  "dealRoom.contract.analysisWarning": "Некоторые документы ещё не проанализированы. ИИ-анализ повышает точность контрактов.",
  "dealRoom.conversation.colleague": "Коллега",
  "dealRoom.details.clients": "Клиенты",
  "dealRoom.documents.previewNotAvailable": "Предварительный просмотр недоступен. Загрузка...",
  "dealRoom.incomingCall.accept": "Принять",
  "dealRoom.incomingCall.decline": "Отклонить",
  "dealRoom.incomingCall.inProgress": "Идёт звонок",
  "dealRoom.incomingCall.started": "{name} начал звонок",
  "dealRoom.messages.connecting": "Подключение к чату...",
  "dealRoom.messages.connectionError": "Не удалось подключиться к беседе.",
  "dealRoom.pendingSignature.loading": "Загрузка статуса подписи...",
  "dealRoom.pendingSignature.signedWaitingOthers": "Успешно подписано. Ожидание других участников.",
  "dealRoom.readOnly.completedMessage": "Эта сделка успешно завершена. Переговорная теперь доступна только для чтения в справочных и аудиторских целях.",
  "dealRoom.signature.signed": "Подписано",
  "dealRoom.signature.signedByYou": "Подписано вами",
  "dealRoom.signature.success": "Контракт успешно подписан!",
  "dealRoom.signaturesList.clients": "Клиенты",
  "dealRoom.signaturesList.dealOwner": "Владелец сделки",
  "dealRoom.signaturesList.pending": "В ожидании",
  "dealRoom.signaturesList.signedOn": "Подписано",
  "dealRoom.signaturesList.title": "Подписи",
  "dealRoom.signaturesList.viewSignatures": "Просмотреть подписи",
  "dealRoom.signedByAll.addPayment": "Добавить оплату",
  "dealRoom.signedByAll.message": "Подписано всеми участниками. Перейти к оплате.",
  "dealRoom.timeline.createdBy": "от {name}",
  "deals.tabs.all": "Все сделки",
  "deals.tabs.my": "Мои сделки",
  "deals.validation.clientRequired": "Выберите хотя бы одного клиента",
  "deals.validation.notesLength": "Заметки должны содержать не более 200 символов",
  "deals.validation.titleLength": "Название должно содержать не более 100 символов",
  "deals.validation.titleRequired": "Название сделки обязательно",
  "documents.readAloud.analyzeFirst": "Сначала проанализируйте этот документ, чтобы прочитать его вслух.",
  "documents.readAloud.error": "Не удалось прочитать вслух",
  "documents.readAloud.title": "Читать вслух",
  "landing.cta.secondary": "Посмотреть пример переговорной",
  "landing.hero.trust": "Бесплатный план. Банковская карта не требуется. Поддержка 11 языков.",
  "landing.socialProof": "Нам доверяют более 500 компаний из 40 стран",
  "landing.useCases.personal.desc": "Закрывайте важные разовые сделки с автомобилями, оборудованием или недвижимостью с чёткой документацией, ИИ-контрактами и простыми безопасными ссылками для обмена документами.",
  "landing.useCases.personal.title": "Крупные личные сделки",
  "landing.useCases.professional.desc": "Приглашайте клиентов загружать документы с помощью ИИ, отслеживайте каждое взаимодействие в защищённых виртуальных офисах и создавайте двуязычные цифровые контракты — всё в одном рабочем пространстве.",
  "landing.useCases.professional.subtitle": "Страхование, недвижимость, кредитование",
  "landing.useCases.professional.title": "Профессиональные услуги",
  "livekit.call": "Звонок",
  "livekit.connecting": "Подключение...",
  "livekit.error.connect": "Не удалось подключиться к звонку. Попробуйте ещё раз.",
  "livekit.error.connection": "Ошибка подключения. Проверьте сеть и попробуйте ещё раз.",
  "livekit.error.permission": "У вас нет разрешения присоединиться к этому звонку.",
  "livekit.hint": "Общайтесь внутри этой сделки вместо переключения между приложениями.",
  "livekit.inCall": "В звонке",
  "livekit.joinCall": "Присоединиться к звонку",
  "livekit.leaveCall": "Покинуть звонок",
  "livekit.participant": "участник",
  "livekit.participants": "участников",
  "messages.readAloud.error": "Не удалось прочитать вслух",
  "messages.readAloud.title": "Читать вслух",
  "nav.companyProfile": "Профиль компании",
  "nav.contacts": "Контакты",
  "nav.directory": "Справочник",
  "nav.products": "Продукты",
  "offices.card.contacts": "{count} контактов",
  "pwa.banner.install": "Установить",
  "pwa.banner.subtitle": "Быстрый доступ, работает офлайн",
  "pwa.banner.title": "Получить приложение PocketFiler",
  "pwa.firefox.hint": "В Firefox найдите иконку установки (⊕) в адресной строке, чтобы добавить это приложение на рабочий стол.",
  "pwa.installApp": "Установить приложение",
  "pwa.installed": "Приложение успешно установлено!",
  "pwa.ios.description": "Добавьте PocketFiler на главный экран для лучшего опыта:",
  "pwa.ios.gotIt": "Понятно",
  "pwa.ios.inToolbar": "в панели инструментов браузера",
  "pwa.ios.inTopRight": "в правом верхнем углу",
  "pwa.ios.shareButton": "кнопку \"Поделиться\"",
  "pwa.ios.step1": "Нажмите",
  "pwa.ios.step2": "Прокрутите вниз и нажмите",
  "pwa.ios.step3": "Нажмите",
  "pwa.ios.title": "Установить PocketFiler",
  "pwa.iosHint": "Нажмите на иконку \"Поделиться\" и \"Добавить на главный экран\" для установки PocketFiler.",
  "pwa.opera.chromeHint": "откройте эту страницу, затем нажмите иконку установки в адресной строке",
  "pwa.opera.desktopNotSupported": "Настольная версия Opera не поддерживает установку PWA. Чтобы установить PocketFiler как приложение, откройте его в Google Chrome или Microsoft Edge.",
  "pwa.opera.edgeHint": "откройте эту страницу, затем нажмите иконку установки (⊕) в адресной строке",
  "pwa.opera.mobileAddPage": "Добавить страницу на",
  "pwa.opera.mobileDescription": "Нажмите иконку + внизу Opera или используйте меню ниже:",
  "pwa.opera.mobileHomeScreen": "Главный экран",
  "pwa.opera.mobileStep1": "Нажмите",
  "pwa.opera.mobileStep1b": "иконку плюс (+) в нижней панели Opera",
  "pwa.opera.mobileStep2": "Или нажмите",
  "pwa.opera.mobileTitle": "Установить PocketFiler в Opera",
  "pwa.opera.recommendedBrowsers": "Используйте вместо этого:",
  "pwa.opera.title": "Недоступно в Opera",
  "qr.clickToExpand": "Нажмите для просмотра в полноэкранном режиме",
  "qr.copied": "Скопировано!",
  "qr.copyLink": "Скопировать ссылку",
  "qr.description": "Покажите этот код клиентам или партнёрам. Когда они его отсканируют, они смогут связаться с вами и начать сделку за секунды.",
  "qr.download": "Скачать",
  "qr.generate": "Создать QR-код",
  "qr.linkCopied": "Ссылка скопирована в буфер обмена",
  "qr.primaryLanguage": "Основной язык",
  "qr.regenerate": "Сбросить",
  "qr.regenerated": "QR-код пересоздан. Старые ссылки больше недействительны.",
  "qr.scanInstructions": "Отсканируйте этот QR-код с помощью PocketFiler или любого QR-сканера для подключения.",
  "qr.scanToConnect": "Сканируйте для подключения",
  "qr.share": "Поделиться",
  "qr.title": "Поделитесь своим QR-кодом PocketFiler",
  "qr.yourLink": "Ваша ссылка для подключения:",
  "recording.completed": "Запись завершена",
  "recording.confirmDelete": "Удалить эту запись?",
  "recording.delete": "Удалить",
  "recording.deleted": "Запись удалена",
  "recording.download": "Скачать",
  "recording.error.delete": "Не удалось удалить запись",
  "recording.error.noCall": "Нет активного звонка. Сначала присоединитесь к звонку.",
  "recording.error.start": "Не удалось начать запись",
  "recording.error.stop": "Не удалось остановить запись",
  "recording.failed": "Запись не удалась",
  "recording.noRecordings": "Пока нет записей",
  "recording.play": "Воспроизвести",
  "recording.playback": "Воспроизведение записи",
  "recording.processing": "Обработка...",
  "recording.start": "Записать",
  "recording.started": "Запись начата",
  "recording.stop": "Стоп",
  "recording.stopped": "Запись остановлена. Обработка...",
  "recording.viewRecordings": "Просмотреть записи",
  "schedule.button": "Запланировать",
  "schedule.cancel": "Отменить",
  "schedule.chooseDateTime": "Пожалуйста, выберите дату и время",
  "schedule.create": "Запланировать",
  "schedule.created": "Запланировано",
  "schedule.dateTime": "Дата и время",
  "schedule.description": "Выберите дату и время. Вы сможете присоединиться к звонку в назначенное время.",
  "schedule.title": "Запланировать звонок или запись",
  "schedule.type": "Тип",
  "schedule.typeCall": "Звонок",
  "schedule.typeRecording": "Запись",
  "schedule.upcoming": "Предстоящие запланированные",
  "settings.profile.accountType": "Тип аккаунта",
  "settings.profile.accountTypeHelp": "Выберите тип, который лучше всего описывает вас",
  "settings.tabs.sharing": "Поделиться QR",
  "support.askAI": "Спросить ИИ",
  "support.availableTimes": "Доступное время",
  "support.booked": "Звонок успешно запланирован!",
  "support.bookingConfirmed": "Отлично, я запланировал ваш звонок на {time}. Вы получите подтверждение со ссылкой на звонок. Есть ли что-то ещё, с чем я могу помочь?",
  "support.bookingError": "Не удалось забронировать время. Попробуйте ещё раз.",
  "support.clearChat": "Очистить чат",
  "support.error": "Не удалось отправить сообщение. Попробуйте ещё раз.",
  "support.inYourTime": "по вашему местному времени",
  "support.inputPlaceholder": "Введите ваш вопрос...",
  "support.openChat": "Открыть поддержку ИИ",
  "support.scheduleCall": "Запланировать звонок в поддержку",
  "support.scheduleTitle": "Запланировать звонок в поддержку",
  "support.slotsError": "Не удалось загрузить доступное время.",
  "support.subtitle": "Спросите что угодно о PocketFiler",
  "support.title": "ИИ поддержка",
  "support.welcome": "Привет! Я ИИ-ассистент PocketFiler. Я могу помочь вам с:\\n\\n- Созданием и управлением сделками\\n- Отправкой документов на подпись\\n- Использованием QR-подключения\\n- Приглашением клиентов\\n- Любыми другими вопросами о PocketFiler\\n\\nЧем могу помочь сегодня?",
  "support.yourTimezone": "Ваш часовой пояс",
  "validation.emailInvalid": "Неверный формат email",
  "validation.emailRequired": "Email обязателен",
  "validation.nameRequired": "Имя обязательно",
  "validation.nameTooLong": "Имя должно быть короче 50 символов",
  "validation.noteTooLong": "Заметка должна быть короче 200 символов",
  "validation.phoneInvalid": "Неверный номер телефона (10-15 цифр)",
  "validation.phoneRequired": "Номер телефона обязателен",
  "deals.column.cancelled": "Отменена",
  "deals.column.completed": "Завершена",
  "deals.column.disputed": "Оспорена",
  "deals.column.escrow_funded": "Эскроу профинансирован",
  "deals.column.on_hold": "На удержании",
  "deals.column.pending_documents": "Ожидание документов",
  "deals.column.pending_payment": "Ожидание оплаты",
  "deals.column.pending_signature": "Ожидание подписи",
  "deals.column.release_requested": "Запрос на выпуск",
  "dashboard.actions.addClient": "Добавить клиента",
  "dashboard.actions.all": "Все",
  "dashboard.actions.createContract": "Создать договор",
  "dashboard.actions.createInvoice": "Создать счёт",
  "dashboard.actions.customize": "Настроить",
  "dashboard.actions.newDeal": "Новая сделка",
  "dashboard.actions.scheduleMeeting": "Запланировать встречу",
  "dashboard.actions.uploadDocument": "Загрузить документ",
  "dashboard.actions.viewAll": "Показать все",
  "dashboard.briefing.default": "Сейчас нет ничего срочного. Ваше рабочее пространство в хорошем состоянии.",
  "dashboard.briefing.title": "Ежедневная сводка",
  "dashboard.empty.activity": "Нет недавней активности.",
  "dashboard.empty.deals": "Пока нет сделок. Создайте первую сделку, чтобы увидеть воронку продаж.",
  "dashboard.empty.documents": "Все документы актуальны.",
  "dashboard.empty.meetings": "Нет предстоящих встреч.",
  "dashboard.empty.tasks": "Нет открытых задач.",
  "dashboard.greeting.afternoon": "Добрый день",
  "dashboard.greeting.evening": "Добрый вечер",
  "dashboard.greeting.morning": "Доброе утро",
  "dashboard.greeting.subtitle": "Вот что происходит в вашем рабочем пространстве.",
  "dashboard.stats.documents": "Документы",
  "dashboard.stats.invoicesDue": "Счета к оплате",
  "dashboard.stats.meetingsComing": "Предстоящие встречи",
  "dashboard.stats.tasksDue": "Задачи к выполнению",
  "dashboard.stats.unreadMessages": "Непрочитанные сообщения",
  "dashboard.widgets.dealPipeline": "Воронка продаж",
  "dashboard.widgets.documentsAttention": "Документы, требующие внимания",
  "dashboard.widgets.gettingStarted": "Начало работы",
  "dashboard.widgets.quickActions": "Быстрые действия",
  "dashboard.widgets.recentActivity": "Недавняя активность",
  "dashboard.widgets.tasks": "Задачи",
  "dashboard.widgets.upcomingMeetings": "Предстоящие встречи",
  "dashboard.steps.createDeal": "Создайте первую сделку",
  "dashboard.steps.addClient": "Добавить клиента",
  "dashboard.steps.uploadDocument": "Загрузить документ",
  "dashboard.steps.scheduleMeeting": "Запланировать встречу",
  "dashboard.steps.createInvoice": "Создать счёт",
  "dashboard.steps.addLogo": "Добавить логотип",
  "dashboard.steps.complete": "завершено",
  "dashboard.time.overdue": "Просрочено",
  "dashboard.time.today": "Сегодня",
  "dashboard.time.tomorrow": "Завтра",
  "dashboard.time.noDate": "Без даты",
  "dashboard.docReason.sent": "Отправлено, ожидание ответа",
  "dashboard.docReason.notAnalyzed": "Ещё не проанализировано",
  "dashboard.docReason.draft": "Черновик, не завершено",
  "dashboard.docReason.needsReview": "Требуется проверка",
  "docViewer.notFound": "Документ не найден",
  "docViewer.previewUnavailable": "Предварительный просмотр недоступен для данного типа файла",
  "docViewer.aiAnalysis": "AI Анализ",
  "docViewer.documentType": "Тип документа",
  "docViewer.summary": "Краткое изложение",
  "docViewer.extractedFields": "Извлеченные поля",
  "docViewer.issues": "Проблемы",
  "docViewer.tags": "Теги",
  "docViewer.noPreviousVersions": "Нет предыдущих версий",
  "docViewer.noActivity": "Активность отсутствует",
  "auth.forgotPassword.title": "Сбросить пароль",
  "guestSign.loading": "Загрузка контракта...",
  "guestSign.unableToLoad": "Невозможно загрузить контракт",
  "guestSign.signed": "Контракт подписан",
  "guestSign.createOwn": "Хотите создавать и управлять собственными контрактами?",
  "guestSign.secureSign": "Безопасное подписание",
  "meeting.ended": "Данная встреча завершена",
  "meeting.cancelled": "Встреча отменена",
  "meeting.notFound": "Встреча не найдена",
  "meeting.joiningAs": "Присоединяется как",
  "meeting.yourName": "Ваше имя *",
  "meeting.emailOptional": "Email (необязательно)",
  "notFound.title": "Страница не найдена",
  "notFound.dashboard": "Перейти к панели управления",
  "notFound.home": "Главная",
  "auth.resetPassword.invalidLink": "Недействительная ссылка",
  "auth.resetPassword.title": "Установить новый пароль",
  "templates.category": "Категория",
  "templates.legal": "Юридические",
  "templates.sales": "Продажи",
  "templates.services": "Услуги",
  "templates.finance": "Финансы",
  "templates.library": "Библиотека шаблонов",
  "templates.libraryDesc": "Готовые к использованию шаблоны документов для вашего бизнеса",
  "templates.noDefault": "Ни один шаблон по умолчанию не соответствует вашему поиску.",
  "templates.noCustom": "Пользовательские шаблоны не найдены",
  "templates.delete": "Удалить шаблон",
  "templates.cancel": "Отменить",
  "uploadRequest.notFound": "Запрос не найден",
  "uploadRequest.error": "Произошла ошибка",
  "uploadRequest.errorDesc": "Пожалуйста, попробуйте позже или свяжитесь с лицом, отправившим данный запрос.",
  "uploadRequest.uploaded": "Документы загружены!",
  "uploadRequest.title": "Запрос на загрузку документа",
  "uploadRequest.fileTypes": "PDF, изображения, Word документы - максимум 25MB",
  "verify.verifying": "Проверка вашего email...",
  "verify.success": "Email подтвержден!",
  "verify.signIn": "Войти",
  "verify.alreadyVerified": "Уже подтвержден",
  "verify.invalidLink": "Недействительная ссылка",
  "verify.backToLogin": "Вернуться к входу",
  "documents.documents": "Документы",
  "documents.allStatus": "Все статусы",
  "documents.newFolder": "Новая папка",
  "documents.clear": "Очистить",
  "documents.noDocumentsYet": "Документов пока нет",
  "documents.status": "Статус",
  "documents.type": "Тип",
  "documents.uploadedBy": "Загружено пользователем",
  "documents.previewNotAvailable": "Предварительный просмотр недоступен",
  "documents.aiAnalysis": "AI-анализ",
  "documents.documentType": "Тип документа",
  "documents.summary": "Краткое изложение",
  "documents.extractedFields": "Извлеченные поля",
  "documents.issues": "Проблемы",
  "documents.notYetAnalyzed": "Еще не проанализирован",
  "documents.details": "Подробности",
  "documents.size": "Размер",
  "documents.date": "Дата",
  "documents.mimeType": "MIME-тип",
  "documents.noTags": "Тегов нет",
  "documents.changeStatus": "Изменить статус",
  "documents.versionHistory": "История версий",
  "documents.noPreviousVersions": "Предыдущих версий нет",
  "documents.activityLog": "Журнал активности",
  "documents.noActivityRecordedYet": "Активность еще не зафиксирована",
  "documents.uploadDocuments": "Загрузить документы",
  "documents.dragAndDropFiles": "Перетащите файлы или нажмите для просмотра. Поддерживаются PDF, изображения, документы Word.",
  "documents.shareDocument": "Поделиться документом",
  "documents.done": "Готово",
  "documents.emailOptional": "Электронная почта (необязательно)",
  "documents.leaveEmptyToJust": "Оставьте пустым, чтобы просто создать ссылку",
  "documents.messageOptional": "Сообщение (необязательно)",
  "documents.cancel": "Отмена",
  "documents.requestDocuments": "Запросить документы",
  "documents.sendASecureUpload": "Отправить клиенту защищенную ссылку для загрузки по электронной почте.",
  "documents.clientEmail": "Электронная почта клиента *",
  "documents.clientName": "Имя клиента",
  "documents.requestedDocuments": "Запрашиваемые документы *",
  "documents.renameFolder": "Переименовать папку",
  "documents.selectADestinationFolder": "Выберите папку назначения.",
  "documents.deleteDocument": "Удалить документ?",
  "settings.individual": "Физическое лицо",
  "settings.business": "Бизнес",
  "settings.buyer": "Покупатель",
  "settings.seller": "Продавец",
  "settings.chooseYourPreferredTheme": "Выберите предпочитаемую тему",
  "settings.light": "Светлая",
  "settings.dark": "Темная",
  "settings.system": "Системная",
  "settings.manufacturing": "Производство",
  "settings.insurance": "Страхование",
  "settings.realEstate": "Недвижимость",
  "settings.automotive": "Автомобильная индустрия",
  "settings.importexport": "Импорт/Экспорт",
  "settings.other": "Другое",
  "settings.brandingWhitelabel": "Брендинг и White-Label",
  "settings.customizeThePocketfilerExperience": "Настройте интерфейс PocketFiler для ваших клиентов.",
  "settings.organizationLogo": "Логотип организации",
  "settings.provideADirectLink": "Предоставьте прямую ссылку на ваш прозрачный PNG или SVG логотип.",
  "settings.primaryThemeColor": "Основной цвет темы",
  "settings.selectAHexColor": "Выберите hex-код цвета для представления основных акцентов вашего бренда.",
  "settings.accentHoverColor": "Акцентный / Цвет при наведении",
  "settings.selectAHexColor1": "Выберите hex-цвет для состояний при наведении, выделений и акцентных элементов.",
  "settings.customDomain": "Пользовательский домен",
  "settings.ensureYouConfigureA": "Убедитесь, что настроили CNAME-запись, указывающую на pocketfiler.com.",
  "settings.cancellationScheduled": "Отмена запланирована",
  "settings.yourLastPaymentFailed": "Ваш последний платеж не прошел. Пожалуйста, обновите способ оплаты для сохранения доступа.",
  "settings.chooseYourPlan": "Выберите ваш план",
  "settings.monthly": "Ежемесячно",
  "settings.save20": "Экономия 20%",
  "settings.current": "Текущий",
  "settings.popular": "Популярный",
  "settings.contactSales": "Связаться с отделом продаж",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Синхронизируйте ваши встречи PocketFiler с Google Calendar",
  "settings.settingsPageErrorDebug": "Ошибка страницы настроек (отладка)",
  "invoices.createInvoice": "Создать счет",
  "invoices.createANewInvoice": "Создать новый счет для клиента",
  "invoices.selectClient": "Выбрать клиента",
  "invoices.dueDate": "Срок оплаты",
  "invoices.clientName": "Имя клиента",
  "invoices.clientEmail": "Электронная почта клиента",
  "invoices.lineItems": "Позиции",
  "invoices.description": "Описание",
  "invoices.qty": "Кол-во",
  "invoices.price": "Цена",
  "invoices.tax": "Налог %",
  "invoices.total": "Итого",
  "invoices.subtotal": "Промежуточный итог:",
  "invoices.discount": "Скидка:",
  "invoices.tax1": "Налог:",
  "invoices.total1": "Итого:",
  "invoices.notesOptional": "Примечания (необязательно)",
  "invoices.invoices": "Счета",
  "invoices.manageAndTrackYour": "Управляйте и отслеживайте ваши счета",
  "invoices.totalInvoiced": "Общая сумма счетов",
  "invoices.paid": "Оплачено",
  "invoices.outstanding": "Задолженность",
  "invoices.totalInvoices": "Всего счетов",
  "invoices.allInvoices": "Все счета",
  "invoices.myInvoices": "Мои счета",
  "invoices.receivedInvoices": "Полученные счета",
  "invoices.noInvoicesYet": "Счетов пока нет",
  "meetings.join": "Присоединиться",
  "meetings.end": "Завершить",
  "meetings.meetingTitle": "Название встречи",
  "meetings.date": "Дата",
  "meetings.time": "Время",
  "meetings.duration": "Продолжительность",
  "meetings.repeat": "Повторение",
  "meetings.doesNotRepeat": "Не повторяется",
  "meetings.weekly": "Еженедельно",
  "meetings.every2Weeks": "Каждые 2 недели",
  "meetings.monthly": "Ежемесячно",
  "meetings.invitePeopleOptional": "Пригласить людей (необязательно)",
  "meetings.cancel": "Отменить",
  "meetings.meetings": "Встречи",
  "companyprofile.companyProfile": "Профиль компании",
  "companyprofile.manageYourBusinessProfile": "Управляйте профилем своей компании и командой",
  "companyprofile.publicProfile": "Публичный профиль",
  "companyprofile.basicInformation": "Основная информация",
  "companyprofile.essentialDetailsAboutYour": "Основные сведения о вашей компании",
  "companyprofile.companyName": "Название компании",
  "companyprofile.tagline": "Слоган",
  "companyprofile.industry": "Отрасль",
  "companyprofile.companyType": "Тип компании",
  "companyprofile.description": "Описание",
  "companyprofile.companyDetails": "Детали компании",
  "companyprofile.additionalInformationAboutYour": "Дополнительная информация о вашем бизнесе",
  "companyprofile.yearEstablished": "Год основания",
  "companyprofile.numberOfEmployees": "Количество сотрудников",
  "companyprofile.certifications": "Сертификаты",
  "companyprofile.enterCertificationsSeparatedBy": "Введите сертификаты, разделенные запятыми",
  "companyprofile.languagesSpoken": "Используемые языки",
  "companyprofile.shippingRegions": "Регионы доставки",
  "companyprofile.contactInformation": "Контактная информация",
  "companyprofile.howPotentialPartnersCan": "Как потенциальные партнеры могут с вами связаться",
  "companyprofile.website": "Веб-сайт",
  "companyprofile.email": "Email",
  "companyprofile.phone": "Телефон",
  "companyprofile.country": "Страна",
  "companyprofile.city": "Город",
  "companyprofile.address": "Адрес",
  "companyprofile.teamMembers": "Члены команды",
  "companyprofile.manageUsersWithinYour": "Управление пользователями в вашей организации",
  "companyprofile.role": "Роль",
  "companyprofile.admin": "Администратор",
  "companyprofile.member": "Участник",
  "companyprofile.viewer": "Наблюдатель",
  "companyprofile.titleOptional": "Должность (необязательно)",
  "companyprofile.name": "Имя",
  "companyprofile.title": "Должность",
  "companyprofile.status": "Статус",
  "companyprofile.actions": "Действия",
  "companyprofile.owner": "Владелец",
  "companyprofile.copyInviteLink": "Скопировать ссылку приглашения",
  "companyprofile.removeMember": "Удалить участника",
  "companyprofile.removeTeamMember": "Удалить члена команды",
  "companyprofile.cancel": "Отменить",
  "products.productsServices": "Продукты и услуги",
  "products.description": "Описание",
  "products.pricing": "Ценообразование",
  "products.price": "Цена",
  "products.unit": "Единица",
  "products.details": "Детали",
  "products.minOrderQty": "Минимальное количество заказа",
  "products.leadTime": "Срок выполнения",
  "products.category": "Категория",
  "products.currency": "Валюта",
  "products.leadTimeDays": "Срок выполнения (дни)",
  "products.active": "Активный",
  "products.showInCatalog": "Показать в каталоге",
  "products.cancel": "Отменить",
  "developersettings.reveal": "Показать",
  "developersettings.copy": "Скопировать",
  "developersettings.hide": "Скрыть",
  "developersettings.securityWarning": "Предупреждение безопасности",
  "developersettings.neverShareThisKey": "Никогда не делитесь этим ключом публично или в клиентском коде",
  "developersettings.anyoneWithThisKey": "Любой, у кого есть этот ключ, может читать и изменять ваши данные",
  "developersettings.ifCompromisedRevokeImmediately": "В случае компрометации немедленно отзовите ключ и создайте новый",
  "developersettings.iUnderstandAndAccept": "Я понимаю и принимаю ответственность за безопасность этого ключа",
  "developersettings.cancel": "Отменить",
  "developersettings.revealKey": "Показать ключ",
  "developersettings.accessDenied": "Доступ запрещен",
  "developersettings.onlyBusinessAccountsHave": "Только бизнес-аккаунты имеют доступ к настройкам разработчика.",
  "developersettings.developerOverview": "Обзор для разработчиков",
  "developersettings.manageYourApiKeys": "Управляйте вашими API-ключами и конечными точками Webhook для интеграций с третьими сторонами.",
  "developersettings.secretApiKeys": "Секретные API-ключи",
  "developersettings.interactiveApiDocumentationRarr": "Интерактивная документация API &rarr;",
  "developersettings.name": "Название",
  "developersettings.key": "Ключ",
  "developersettings.createdAt": "Создано",
  "developersettings.status": "Статус",
  "developersettings.actions": "Действия",
  "developersettings.webhookEndpoints": "Конечные точки Webhook",
  "developersettings.url": "URL",
  "developersettings.events": "События",
  "developersettings.description": "Описание",
  "developersettings.done": "Готово",
  "developersettings.addWebhookEndpoint": "Добавить конечную точку Webhook",
  "developersettings.payloadUrl": "URL полезной нагрузки",
  "developersettings.eventsToSend": "События для отправки",
  "developersettings.sendMeEverything": "Отправлять мне всё (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Статус сделки изменён (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Документ загружен (document.uploaded)",
  "developersettings.descriptionOptional": "Описание (необязательно)",
  "analytics.noDataAvailableFor": "Нет доступных данных за данный период.",
  "analytics.noDealsFound": "Сделки не найдены.",
  "analytics.noClientDataAvailable": "Нет доступных данных клиентов за данный период.",
  "analytics.client": "Клиент",
  "analytics.invoices": "Счета",
  "analytics.revenue": "Выручка",
  "analytics.totalPipeline": "Общий объём воронки продаж",
  "analytics.noRecentActivityFor": "Нет недавней активности за данный период.",
  "analytics.pipelineOverview": "Обзор воронки продаж",
  "analytics.goToDeals": "Перейти к сделкам",
  "analytics.analyticsDashboard": "Панель аналитики",
  "analytics.trackYourBusinessPerformance": "Отслеживайте производительность и аналитику вашего бизнеса",
  "analytics.last7Days": "Последние 7 дней",
  "analytics.last30Days": "Последние 30 дней",
  "analytics.last90Days": "Последние 90 дней",
  "analytics.lastYear": "Прошлый год",
  "analytics.overview": "Обзор",
  "analytics.myPerformance": "Моя производительность",
  "analytics.currentDealsByStatus": "Текущие сделки по статусу",
  "analytics.revenueTrendsOverLast": "Тенденции выручки за последние 6 месяцев",
  "analytics.accountsGeneratingTheMost": "Аккаунты, приносящие наибольшую выручку",
  "analytics.currentCashFlowOverview": "Обзор текущего денежного потока",
  "analytics.latestBusinessActivitiesAnd": "Последние бизнес-активности и обновления",
  "compliance.complianceCenter": "Центр соответствия",
  "compliance.hsCodesTariffsSanctions": "HS-коды, тарифы, проверка санкций и экспортный контроль",
  "compliance.hsCodeClassification": "Классификация HS-кодов",
  "compliance.productDescription": "Описание продукта",
  "compliance.tariffCalculator": "Калькулятор тарифов",
  "compliance.estimateImportDutiesBased": "Оценка импортных пошлин на основе HS-кода и торгового маршрута.",
  "compliance.hsCode": "HS-код",
  "compliance.declaredValueUsd": "Заявленная стоимость (USD)",
  "compliance.originCountry": "Страна происхождения",
  "compliance.destinationCountry": "Страна назначения",
  "compliance.dutyRate": "Ставка пошлины:",
  "compliance.totalRate": "Общая ставка:",
  "compliance.estDuty": "Ориент. пошлина:",
  "compliance.totalEstCost": "Общая ориент. стоимость:",
  "compliance.tradeAgreements": "Торговые соглашения:",
  "compliance.sanctionsScreening": "Проверка санкций",
  "compliance.screenEntitiesAgainstOfac": "Проверка субъектов по списку SDN OFAC и страновым санкциям.",
  "compliance.entityName": "Название субъекта",
  "compliance.type": "Тип",
  "compliance.company": "Компания",
  "compliance.individual": "Физическое лицо",
  "compliance.vessel": "Судно",
  "compliance.countryOptional": "Страна (необязательно)",
  "compliance.usSanctionedCountries": "Страны под санкциями США",
  "compliance.exportControlCheck": "Проверка экспортного контроля",
  "compliance.aipoweredEaritarClassificationGuidance": "Рекомендации по классификации EAR/ITAR на базе ИИ. Не является юридической консультацией.",
  "compliance.producttechnologyDescription": "Описание продукта/технологии",
  "compliance.hsCodeOptional": "HS-код (необязательно)",
  "compliance.endUseOptional": "Конечное использование (необязательно)",
  "compliance.licenseRequired": "Требуется лицензия",
  "compliance.recommendations": "Рекомендации:",
  "compliance.complianceHistory": "История соответствия",
  "compliance.recentComplianceChecksFor": "Недавние проверки соответствия для вашей организации.",
  "compliance.noComplianceChecksYet": "Пока нет проверок соответствия. Выполните первую проверку выше.",
  "intelligence.marketIntelligence": "Рыночная аналитика",
  "intelligence.anonymizedTradeDataAnd": "Анонимизированные торговые данные и показатели с платформы PocketFiler",
  "intelligence.demandByCategory": "Спрос по категориям",
  "intelligence.whatBuyersAreSourcing": "Что покупатели ищут на платформе (последние 90 дней)",
  "intelligence.noDemandDataYet": "Пока нет данных о спросе. Данные появляются по мере создания запросов цен на платформе.",
  "intelligence.byIndustry": "По отраслям",
  "intelligence.noSupplierDataYet": "Пока нет данных о поставщиках.",
  "intelligence.byCountry": "По странам",
  "intelligence.byType": "По типам",
  "intelligence.byVerification": "По верификации",
  "intelligence.noDataYet": "Пока нет данных.",
  "intelligence.yourPerformanceVsPlatform": "Ваша производительность относительно платформы",
  "intelligence.seeHowYouStack": "Посмотрите, как вы выглядите на фоне средних показателей платформы",
  "intelligence.completeSomeDealsTo": "Завершите несколько сделок, чтобы увидеть показатели.",
  "virtualoffices.virtualOffices": "Виртуальные офисы",
  "virtualoffices.manageYourBrandedWorkspaces": "Управляйте вашими брендированными рабочими пространствами",
  "virtualoffices.officeName": "Название офиса",
  "virtualoffices.industry": "Отрасль",
  "virtualoffices.languagesServed": "Обслуживаемые языки",
  "virtualoffices.descriptionOptional": "Описание (необязательно)",
  "virtualoffices.documentChecklist": "Контрольный список документов",
  "virtualoffices.languages": "Языки",
  "tasks.tasks": "Задачи",
  "tasks.noTasksYet": "Пока нет задач",
  "tasks.dragTasksHere": "Перетащите задачи сюда",
  "tasks.createNewTask": "Создать новую задачу",
  "tasks.descriptionOptional": "Описание (необязательно)",
  "tasks.relatedDealOptional": "Связанная сделка (необязательно)",
  "tasks.noDealAttached": "Сделка не привязана",
  "tasks.assignees": "Исполнители",
  "tasks.noTeamMembersAvailable": "Нет доступных членов команды. Только активные участники могут быть назначены.",
  "tasks.cancel": "Отменить",
  "tasks.description": "Описание",
  "tasks.status": "Статус",
  "tasks.relatedDeal": "Связанная сделка",
  "tasks.noAssignees": "Нет исполнителей",
  "tasks.areYouAbsolutelySure": "Вы абсолютно уверены?",
  "events.events": "События",
  "events.tradeShowsWebinarsAnd": "Выставки, вебинары и сетевые мероприятия",
  "events.createEvent": "Создать событие",
  "events.title": "Название",
  "events.description": "Описание",
  "events.category": "Категория",
  "events.type": "Тип",
  "events.locationUrl": "Местоположение / URL",
  "events.startDateTime": "Дата и время начала",
  "events.endDateTime": "Дата и время окончания",
  "events.maxAttendeesOptional": "Максимальное количество участников (необязательно)",
  "events.cancel": "Отмена",
  "events.allCategories": "Все категории",
  "events.noEventsFoundCreate": "События не найдены. Создайте первое!",
  "events.featured": "Рекомендуемые",
  "events.previous": "Предыдущий",
  "events.next": "Следующий",
  "status.pendingDocuments": "Ожидание документов",
  "status.pendingSignature": "Ожидание подписи",
  "status.pendingPayment": "Ожидание оплаты",
  "status.completed": "Завершен",
  "status.updated": "Обновлен",
  "status.onHold": "Приостановлен",
  "activity.deal": "Сделка",
  "activity.action.analyzed": "Проанализирован",
  "activity.action.uploaded": "Загружен",
  "activity.action.downloaded": "Скачан",
  "activity.action.previewed": "Просмотрен",
  "activity.action.shared": "Поделился",
  "activity.action.status_changed": "Статус изменен",
  "activity.action.updated": "Обновлен",
  "activity.action.created": "Создан",
  "activity.action.archived": "Архивирован",
  "activity.action.restored": "Восстановлен",
  "analytics.totalRevenue": "Общая выручка",
  "analytics.totalDeals": "Общее количество сделок",
  "analytics.conversionRate": "Коэффициент конверсии",
  "analytics.avgDealValue": "Средняя стоимость сделки",
  "analytics.dealPipeline": "Воронка продаж",
  "analytics.monthlyRevenue": "Ежемесячная выручка",
  "analytics.topClientsByRevenue": "Топ клиентов по выручке",
  "analytics.invoiceHealth": "Состояние счетов",
  "analytics.paid": "Оплачено",
  "analytics.pendingPayment": "Ожидает оплаты",
  "companyprofile.saveProfile": "Сохранить профиль",
  "companyprofile.makeVisible": "Сделать вашу компанию видимой в директории",
  "companyprofile.tab.basicInfo": "Основная информация",
  "companyprofile.tab.details": "Детали",
  "companyprofile.tab.contact": "Контакты",
  "companyprofile.tab.team": "Команда",
  "companyprofile.tab.verification": "Верификация",
  "companyprofile.selectType": "Выберите тип",
  "companyprofile.describePlaceholder": "Опишите вашу компанию, продукты и услуги...",
  "companyprofile.industry.other": "Другое",
  "companyprofile.preview": "Предварительный просмотр",
  "companyprofile.ph.companyName": "Ваша Компания ООО",
  "companyprofile.ph.tagline": "Качественная продукция, глобальный охват",
  "companyprofile.ph.selectIndustry": "Выберите отрасль",
  "companyprofile.ph.selectSize": "Выберите размер",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (через запятую)",
  "companyprofile.ph.languages": "Русский, Английский, Китайский",
  "companyprofile.ph.exportRegions": "Северная Америка, Европа, Азия",
  "companyprofile.ph.selectCountry": "Выберите страну",
  "companyprofile.ph.city": "Москва",
  "companyprofile.ph.teamName": "Имя участника команды",
  "companyprofile.ph.addTitle": "Добавить должность...",
  "companyprofile.inviteTeamMember": "Пригласить участника команды",
  "companyprofile.invitationSent": "Приглашение успешно отправлено",
  "virtualoffices.newOffice": "Новый офис",
  "virtualoffices.createOffice": "Создать виртуальный офис",
  "virtualoffices.reviewChecklist": "Просмотреть контрольный список документов",
  "virtualoffices.setupDesc": "Создайте новое брендированное рабочее пространство для вашего бизнеса",
  "virtualoffices.customizeDesc": "Настройте документы, которые вам необходимы от клиентов",
  "virtualoffices.ph.officeName": "например, Страховая компания Гарсия - Автомобильные полисы",
  "virtualoffices.ph.description": "Опишите специализацию вашего офиса...",
  "virtualoffices.ph.addDocument": "Добавить пользовательский документ...",
  "virtualoffices.generating": "Генерируется...",
  "virtualoffices.aiChecklist": "Сгенерированный ИИ контрольный список для",
  "virtualoffices.clients": "Клиенты",
  "virtualoffices.pending": "В ожидании",
  "virtualoffices.invite": "Пригласить",
  "virtualoffices.ind.manufacturing": "Производство",
  "virtualoffices.ind.insurance": "Страхование",
  "virtualoffices.ind.real_estate": "Недвижимость",
  "virtualoffices.ind.automotive": "Автомобильная промышленность",
  "virtualoffices.ind.import_export": "Импорт/Экспорт",
  "virtualoffices.ind.other": "Другое",
  "messages.conversations": "Беседы",
  "messages.searchPlaceholder": "Поиск сообщений...",
  "messages.noConversations": "Нет бесед",
  "messages.send": "Отправить",
  "messages.selectConversation": "Выберите беседу",
  "messages.selectConversationDesc": "Выберите беседу из боковой панели, чтобы начать общение",
  "messages.support": "Поддержка",
  "messages.client": "Клиент",
  "messages.deal": "Сделка",
  "meetings.subtitle": "Планирование и управление видеоконференциями",
  "meetings.upcoming": "Предстоящие",
  "meetings.past": "Прошедшие",
  "meetings.schedule": "Запланировать",
  "meetings.startInstant": "Начать мгновенно",
  "meetings.startNow": "Начать сейчас",
  "meetings.noPast": "Нет прошедших собраний",
  "meetings.noUpcoming": "Нет предстоящих собраний",
  "meetings.createMeeting": "Создать собрание",
  "meetings.startInstantMeeting": "Начать мгновенное собрание",
  "meetings.scheduleMeeting": "Запланировать собрание",
  "meetings.scheduleDesc": "Запланировать видеоконференцию и отправить приглашения.",
  "meetings.invitePeople": "Пригласить участников (необязательно)",
  "meetings.15min": "15 минут",
  "meetings.30min": "30 минут",
  "meetings.45min": "45 минут",
  "meetings.allowRecording": "Разрешить запись",
  "meetings.recordingDesc": "Позволяет ведущему записывать данное собрание",
  "meetings.waitingRoom": "Зал ожидания",
  "meetings.waitingRoomDesc": "Участники должны быть допущены ведущим перед присоединением",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "Отменить это собрание?",
  "meetings.cancelMeeting": "Отменить собрание",
  "documents.title": "Документы",
  "documents.viewAll": "Просмотреть все",
  "documents.archived": "Архивированные",
  "documents.requestDocs": "Запросить документы",
  "documents.upload": "Загрузить",
  "documents.allDocuments": "Все документы",
  "documents.searchPlaceholder": "Поиск документов...",
  "documents.addTag": "Добавить тег...",
  "documents.uploadDesc": "Перетащите файлы или нажмите для обзора. Поддерживаются PDF, изображения, документы Word.",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "Вот запрошенный вами документ...",
  "documents.requestDesc": "Отправить клиенту защищенную ссылку для загрузки по электронной почте.",
  "documents.namePlaceholder": "Иван Иванов",
  "documents.requestMsgPlaceholder": "Пожалуйста, загрузите следующие документы...",
  "documents.folderName": "Название папки",
  "documents.selectDestination": "Выберите папку назначения.",
  "documents.statusUploaded": "Загружено",
  "documents.statusAnalyzed": "Проанализировано",
  "documents.statusArchived": "Архивировано",
  "documents.allTypes": "Все типы",
  "documents.inArchive": "в архиве",
  "templates.allTemplates": "Все шаблоны",
  "templates.editTemplate": "Редактировать шаблон",
  "templates.createCustomTemplate": "Создать пользовательский шаблон",
  "templates.editDesc": "Обновите ваш шаблон документа",
  "templates.createDesc": "Создайте собственный многоразовый шаблон документа",
  "templates.ph.templateName": "например, Пользовательское соглашение о неразглашении",
  "templates.ph.description": "Краткое описание шаблона",
  "templates.ph.content": "Введите содержимое вашего шаблона здесь...",
  "templates.saving": "Сохранение...",
  "templates.creating": "Создание...",
  "templates.saveChanges": "Сохранить изменения",
  "templates.createTemplate": "Создать шаблон",
  "templates.searchPlaceholder": "Поиск шаблонов...",
  "templates.popularTemplates": "Популярные шаблоны",
  "templates.defaultTemplates": "Шаблоны по умолчанию",
  "templates.deleteTemplate": "Удалить шаблон",
  "templates.preview": "Предварительный просмотр",
  "templates.description": "Описание",
  "products.searchPlaceholder": "Поиск товаров...",
  "products.ph.service": "Консалтинговые услуги",
  "products.ph.product": "Виджет Про 3000",
  "products.selectCategory": "Выберите категорию",
  "products.ph.describe": "Опишите ваш товар или услугу...",
  "products.noMatches": "Совпадений не найдено",
  "products.noProducts": "Товаров или услуг пока нет",
  "products.serviceDetails": "Детали услуги",
  "products.productDetails": "Детали товара",
  "products.inactive": "Неактивен",
  "products.deleteConfirm": "Удалить данный элемент?",
  "products.saveChanges": "Сохранить изменения",
  "products.addItem": "Добавить элемент",
  "products.priceOnRequest": "Цена по запросу",
  "products.perUnit": "За единицу",
  "tasks.searchPlaceholder": "Поиск задач...",
  "tasks.ph.title": "например, Проверить юридические документы",
  "tasks.ph.description": "Добавьте дополнительную информацию к данной задаче...",
  "tasks.selectDeal": "Выберите сделку для прикрепления",
  "tasks.noTasks": "В данной колонке нет задач",
  "tasks.deleteTask": "Удалить задачу",
  "settings.tabs.branding": "Брендинг",
  "settings.tabs.payments": "Платежи",
  "settings.tabs.plan": "Тариф",
  "settings.tabs.integrations": "Интеграции",
  "settings.appearance": "Внешний вид",
  "settings.saveBranding": "Сохранить брендинг",
  "settings.yourPlan": "Ваш тариф",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "URL календарной ленты создан!",
  "settings.plan.free": "Бесплатный",
  "settings.plan.pro": "Профессиональный",
  "settings.plan.smallBusiness": "Малый бизнес",
  "settings.plan.businessPro": "Бизнес Про",
  "settings.plan.scale": "Масштаб",
  "settings.plan.enterprise": "Корпоративный",
  "dealroom.meetings": "Совещания",
  "dealroom.startMeeting": "Начать совещание",
  "dealroom.noMeetings": "К данной сделке пока не привязаны совещания",
  "dealroom.noMeetingsDesc": "Начните совещание или запланируйте его для начала работы",
  "dealroom.failedCreateMeeting": "Не удалось создать совещание",
  "dealroom.finalizedContract": "Финализированный договор — готов к подписанию",
  "dealroom.previewNotSupported": "Предварительный просмотр не поддерживается",
  "dealroom.aiMayTakeMoment": "Это может занять некоторое время.",
  "dealroom.aiAnalysisGenerated": "ИИ-анализ был сгенерирован для следующих документов:",
  "dealroom.docsUnanalyzed": "Следующие документы остаются неанализированными:",
  "dealroom.analyzingDocs": "Анализ документов...",
  "dealroom.finalizeWarning": "Данное действие невозможно отменить. Статус сделки изменится на «Ожидает подписания», и все стороны смогут подписать договор.",
  "dealroom.cannotRevert": "Невозможно отменить статус «Ожидает подписания»",
  "compliance.ph.productDesc": "например, болты из нержавеющей стали, M10 x 50мм...",
  "compliance.ph.exportDesc": "Опишите продукт или технологию, подлежащую экспорту...",
  "compliance.select": "Выбрать...",
  "compliance.selectCountry": "Выбрать страну...",
  "events.tradeShow": "Торговая выставка",
  "events.webinar": "Вебинар",
  "events.networking": "Нетворкинг",
  "events.conference": "Конференция",
  "events.workshop": "Семинар",
  "events.ph.title": "Название мероприятия",
  "events.ph.location": "Адрес места проведения или ссылка на встречу",
  "events.ph.maxAttendees": "Оставьте пустым для неограниченного количества",
  "events.searchPlaceholder": "Поиск мероприятий...",
  "events.cancelRsvp": "Отменить RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "Истек",
  "rfq.createRfq": "Создать запрос коммерческого предложения",
  "rfq.visibility": "Видимость",
  "rfq.public": "Публичный - Видят все поставщики",
  "rfq.private": "Частный - Только по приглашению",
  "rfq.quantity": "Количество",
  "rfq.unit": "Единица измерения",
  "rfq.pieces": "Штуки",
  "rfq.kilograms": "Килограммы",
  "rfq.meters": "Метры",
  "rfq.squareMeters": "Квадратные метры",
  "rfq.units": "Единицы",
  "rfq.sets": "Комплекты",
  "rfq.boxes": "Коробки",
  "rfq.deliveryLocation": "Место доставки",
  "rfq.deliveryDeadline": "Срок доставки",
  "rfq.specialRequirements": "Особые требования",
  "rfq.title": "Запросы коммерческих предложений",
  "rfq.subtitle": "Просматривайте запросы на поставку или разместите свой",
  "rfq.rfqsPosted": "Размещено RFQ",
  "rfq.openRfqs": "Открытые RFQ",
  "rfq.quotesSent": "Отправлено предложений",
  "rfq.winRate": "Процент выигранных сделок",
  "rfq.allCategories": "Все категории",
  "rfq.noRfqsFound": "RFQ не найдены",
  "rfq.noRfqsYet": "Пока нет RFQ",
  "meetings.biweekly": "Каждые 2 недели",
  "meetings.cancelSeries": "Отменить всю серию",
  "meetings.cancelThisMeeting": "Отменить эту встречу",
  "meetings.nextInSeries": "Следующая в серии",
  "nav.contractTemplates": "Договоры",
  "contracts.title": "Шаблоны договоров",
  "contracts.subtitle": "Генерация юридических документов с помощью ИИ. Выберите шаблон для начала.",
  "documents.create": "Создать",
  "createDoc.untitledDocument": "Документ без названия",
  "createDoc.save": "Сохранить",
  "createDoc.export": "Экспорт",
  "createDoc.aiAssist": "ИИ помощник",
  "createDoc.generate": "Сгенерировать",
  "createDoc.generating": "Генерация...",
  "createDoc.cancel": "Отмена",
  "createDoc.translate": "Перевести",
  "createDoc.translateTitle": "Перевести документ",
  "createDoc.translateTo": "Перевести на",
  "createDoc.translateNow": "Перевести",
  "createDoc.translating": "Перевод...",
  "createDoc.translated": "Документ успешно переведён",
  "createDoc.translateFailed": "Ошибка перевода",
  "verification.status": "Статус верификации",
  "verification.inProgress": "Верификация в процессе",
  "verification.getVerified": "Пройти верификацию",
  "verification.cancelRequest": "Отменить запрос",
  "verification.submit": "Отправить на верификацию",
  "verification.submitting": "Отправка...",
  "verification.uploadDocs": "Загрузить документы",
  "verification.level": "Уровень верификации",
  "verification.selectDocType": "Выберите тип документа...",
  "contracts.generate": "Сгенерировать",
  "contracts.backToTemplates": "Назад к шаблонам",
  "contracts.required": "Обязательно",
  "contracts.modify": "Изменить",
  "contracts.finalize": "Завершить",
  "contracts.applyChanges": "Применить изменения",
  "contracts.confirmDelete": "Удалить черновик?",
  "contracts.generating": "Создание документа...",
  "templates.deleting": "Удаление...",
  "templates.noDescription": "Без описания.",
  "templates.use": "Использовать",
  "templates.lib.ndaMutual": "Взаимное соглашение о неразглашении",
  "templates.lib.purchaseAgreement": "Договор купли-продажи",
  "templates.lib.serviceAgreement": "Договор оказания услуг",
  "templates.lib.priceQuote": "Ценовое предложение",
  "templates.lib.invoice": "Счёт-фактура",
  "templates.lib.loi": "Письмо о намерениях",
  "settings.security": "Безопасность",
  "security.twoFactor": "Двухфакторная аутентификация",
  "security.enabled": "Включено",
  "security.disabled": "Отключено",
  "security.enable2FA": "Включить 2FA",
  "security.disable": "Отключить",
  "security.activeSessions": "Активные сессии",
  "security.logoutAll": "Выйти везде",
  "security.loginHistory": "История входов",
  "security.verify": "Подтвердить",
  "security.cancel": "Отмена",
  "security.password": "Пароль",
  "security.done": "Готово",
  "feedback.button": "Отзыв",
  "feedback.title": "Отправить Отзыв",
  "feedback.typeBug": "Ошибка",
  "feedback.typeFeature": "Функция",
  "feedback.typeGeneral": "Общее",
  "feedback.submit": "Отправить",
  "feedback.thanks": "Спасибо! Мы разберёмся.",
};

export default ru;
